import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const BackRedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handlePopState = (event) => {
      //console.log('PopState event triggered:', event);
      //console.log('Current location:', location.pathname);
      
      const token = localStorage.getItem('token');
      
      // Only redirect to login if there's no token
      if (!token) {
        //console.log('No token found, redirecting to login');
        navigate('/', { replace: true });
        return;
      }

      // Check if we're trying to go back to a protected route without token
      if (location.pathname.startsWith('/home') && !token) {
        //console.log('Protected route without token, redirecting to login');
        navigate('/', { replace: true });
        return;
      }

      // Allow normal browser history navigation for authenticated users
      //console.log('Allowing normal browser navigation');
      // The browser will handle the navigation naturally
    };

    //console.log('Adding popstate event listener');
    window.addEventListener('popstate', handlePopState);
    return () => {
      //console.log('Removing popstate event listener');
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate, location]);

  return null;
};

export default BackRedirectHandler;
